import Icon from '../../icons'


const Label: React.FC<{
    text: string
    isBold?: boolean
    required?: boolean
    isCapitalize?: boolean
    isError?: boolean
    info?: string
    isElipsis?: boolean

}> = ({ text, isBold, required, isCapitalize, isError, info, isElipsis = false }) => (
    <div className="flex items-center gap-1">
        <p  className={`text-sm ${isBold ? 'font-bold' : 'font-normal'} ${isCapitalize ? 'capitalize' : ''} ${isElipsis? `text-ellipsis overflow-hidden whitespace-nowrap` : ''} ${isError ? 'text-red-500' : ''} text-[0.938rem] leading-tight`}>
            {text}
            {required && <span className="text-red-600 ml-1">*</span>}
        </p>
        {info && (
            <span className="cursor-pointer text-secondary">
                <Icon name="info" size={16} title={info} />
            </span>
        )}
    </div>
)
export default Label